module.exports = __webpack_public_path__ + "img/infinity_horcrux.1505e7fd.jpg";